import React from 'react';
import { Row, Col, Card, CardBody, Button, Collapse, Tooltip } from 'reactstrap';
import { PropTypes } from "prop-types";
import { Link } from 'react-router-dom';

class Legend extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      collapseBtnIcon: "icon-minimal-down",
      tooltipNameOpen: false,
      collapse: false
    }
  }

  componentDidMount() {
    //fixed position of the legend
    // window.addEventListener('scroll', this.handleScroll);
  }

  // handleScroll(event) {
  //   if (document.scrollingElement.scrollTop > 72) {
  //     const legendHeight = document.getElementById('legend').clientHeight;
  //     document.getElementById("legend").style.position = 'fixed';
  //     document.getElementById("legend").style.width = 'calc(100vw - 296px)';
  //     document.getElementById("legend").style.zIndex = 1;
  //     document.getElementById("legend").style.top = "8px";
  //     document.getElementById("legend-space").style.height = legendHeight + "px";
  //   } else {
  //     document.getElementById("legend").style.position = "unset";
  //     document.getElementById("legend").style.width = "unset";
  //     document.getElementById("legend").style.top = "unset";
  //     document.getElementById("legend-space").style.height = "0px";
  //   }

  // }

  toggleCollapseBtnIcon() {
    let { collapseBtnIcon } = this.state
    if (collapseBtnIcon == "icon-minimal-down") {
      this.setState({
        collapseBtnIcon: "icon-minimal-up"
      })
    } else {
      this.setState({
        collapseBtnIcon: "icon-minimal-down"
      })
    }
  }

  toggleTooltip = targetName => {
    if (!this.state[targetName]) {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: true
        }
      });
    } else {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: !this.state[targetName].tooltipOpen
        }
      });
    }
  };

  isTooltipOpen = targetName => {
    return this.state[targetName] ? this.state[targetName].tooltipOpen : false;
  };

  toggle() {
    let { vertical } = this.props
    if (vertical) {
      this.props.resize(!this.state.collapse)
    }
    this.toggleCollapseBtnIcon()
    this.setState({ collapse: !this.state.collapse });
  }

  render() {
    let { collapseBtnIcon } = this.state
    let renderClients = this.props.clientsData.map((client) => {
      return (
        <Col className="client-legend-col" md={this.props.vertical ? "12" : "3"} key={client.id}>
          <p className="client-legend" style={{ backgroundColor: "rgba(" + client.color + ",1)" }}></p>
          <Link to={'/statistiche-competitor/' + client.id} alt="Statistiche competitor">
            <i className="tim-icons icon-paper pull-right pl-3" />
          </Link>
          <p id={`btn-${client.id}`} className="client-legend-name">{client.label.substring(0, 12) + "..."}</p>

          <Tooltip placement="top"
            isOpen={this.isTooltipOpen(`btn-${client.id}`)}
            target={`btn-${client.id}`}
            toggle={() => this.toggleTooltip(`btn-${client.id}`)}> {client.name}</Tooltip>
        </Col>)

    })
    return (
      <>
        <Row id="legend">
          <Col md="12" className={this.props.vertical ? "position-absolute" : ""}>
            <Card style={this.props.vertical && this.state.collapse ? { height: "calc(100vh - 90px)" } : { height: "unset" }}>
              <Row>
                <Col md="10"><h3 className="text-left m-3">COMPETITOR</h3></Col>
                <Col md="2"><Button color="primary" className="animation-on-hover float-right text-center m-3" size="sm" id="toggler" onClick={() => { this.toggle() }}><i className={"tim-icons " + collapseBtnIcon} /></Button></Col>
              </Row>
              <Collapse
                isOpen={this.state.collapse} className="pb-3">
                <CardBody>
                  <Row>
                    {renderClients}
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row id="legend-space"></Row>
      </>
    )
  }
}

Legend.propTypes = {
  clientsData: PropTypes.array.isRequired,
};

export default Legend;